import { Link } from 'react-router-dom';
import MyIpoLogo from 'src/assets/images/logo_header.png';
import { DocumentUriConstant } from 'src/constants';
import { Spacing } from 'src/styles';

import { MTypography } from '../MTypography/MTypography';

import * as Styles from './Footer.Styles';
import FooterText from './FooterText';

export const footerPages = [
  {
    path: '/terms-of-use',
    title: 'Terms of Use',
  },
  {
    path: '/static/docs/Privacy_Policy_Revision_2025.pdf',
    title: 'NOTICE OF MY IPO, LLC PRIVACY POLICY',
    footerLinkTitle: 'Privacy Policy',
    openSeparately: true,
  },
  {
    path: 'https://legacy.tradingblock.com/Docs/Agreements/tb/MyIPO_Business_Continuity_Plan_Disclosure.pdf',
    title: 'Business Continuity Plan',
    footerLinkTitle: 'Business Continuity Plan',
    openSeparately: true,
  },
  {
    path: 'https://www.tradingblock.com/account/orderqualityreports.aspx',
    title: 'SEC Rule 606',
  },
  {
    path: 'https://legacy.tradingblock.com/Docs/Agreements/tb/AOS_MyIPO_Form_CRS.pdf',
    title: 'Form CRS',
    openSeparately: true,
  },
];

export const Footer = () => {
  return (
    <div className={Styles.footerMain}>
      <div className={Styles.sectionContainer}>
        <div className={Styles.footerLogoSection}>
          <img src={MyIpoLogo} alt='My IPO logo' className={Styles.footerLogo} />
          <Link to='/about' className={Styles.footerTopLink} target={'_top'}>
            About
          </Link>

          <Link to='/offers' className={Styles.footerTopLink} target={'_top'}>
            Offers
          </Link>
        </div>
        <MTypography variant='body1' className={Spacing.mb16}>
          Need Assistance? Click{' '}
          <a href={DocumentUriConstant.MY_IPO_QUICK_GUIDE} target='_blank' rel='noreferrer'>
            here
          </a>{' '}
          to download a step by step guide on how to Sign up, Complete Account, and Place Order.
        </MTypography>
        <div>
          <FooterText />
        </div>
        <div className={Styles.subLinksSection}>
          {footerPages.map(({ path, title, openSeparately, footerLinkTitle }: any) =>
            path.startsWith('http') || openSeparately ? (
              <a key={path} rel='noreferrer' href={path} target='_blank' className={Styles.footerSubLink}>
                {footerLinkTitle || title}
              </a>
            ) : (
              <Link
                key={path}
                to={path}
                target={path.startsWith('http') ? '_blank' : '_top'}
                className={Styles.footerSubLink}>
                {footerLinkTitle || title}
              </Link>
            ),
          )}
        </div>
      </div>
    </div>
  );
};
